import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';
import { PAGE_TITLE_HEIGHT } from '../styles';

interface PageTitleProps {
	isWide: boolean;
}

const StyledPageTitle = styled('div')`
	box-sizing: border-box;
	flex: 0 0 ${PAGE_TITLE_HEIGHT}px;
	padding-left: ${(props: PageTitleProps) => props.isWide ? '114px' : '40px'};
	padding-right: 10px;
	background-color: ${NewStyleColor.Grey950};
	font-family: HelveticaNeue, sans-serif;
	font-size: 13px;
	line-height: ${PAGE_TITLE_HEIGHT}px;
	color: ${NewStyleColor.White};
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;

	@media only screen and (min-width: 1024px) {
		padding-left: ${(props: PageTitleProps) => props.isWide ? '174px' : '40px'};
	}
`;

const StyledSeparator = styled('span')`
	position: relative;
	top: -1px;
	margin: 0 10px;
`;

export {
	StyledPageTitle,
	StyledSeparator,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/PageTitle/styles.ts